export default {
    'zh_CN': {
        'property.maintenance.id.label': '主键',
        'property.maintenance.id.holder': '请输入主键',
        
        
        'property.maintenance.id.required': '主键必填',
        'property.maintenance.maintenanceType.label': '维修类型',
        'property.maintenance.maintenanceType.holder': '请输入维修类型',
        
        
        'property.maintenance.maintenanceType.dictionary': ()=>[{value:1,label:'办公用品'},{value:2,label:'房屋'},{value:3,label:'其他'}],
        'property.maintenance.maintenanceType.required': '维修类型必填',
        'property.maintenance.maintenanceTime.label': '维修时间',
        'property.maintenance.maintenanceTime.holder': '请输入维修时间',
        'property.maintenance.maintenanceTime.required': '维修时间必填',
        'property.maintenance.maintenancePeople.label': '维护员工',
        'property.maintenance.maintenancePeople.holder': '请输入维护员工',
        
        
        'property.maintenance.maintenancePeople.required': '维护员工必填',
        'property.maintenance.maintenanceContent.label': '维修内容',
        'property.maintenance.maintenanceContent.holder': '请输入维修内容',
        'property.maintenance.maintenanceContent.max': '维修内容最多65535个字符',
        
        'property.maintenance.maintenanceContent.required': '维修内容必填',
        'property.maintenance.maintenanceMoney.label': '维修花费',
        'property.maintenance.maintenanceMoney.holder': '请输入维修花费',
        'property.maintenance.maintenanceMoney.max': '维修花费最多20个字符',
        
        'property.maintenance.maintenanceMoney.required': '维修花费必填',
        'property.maintenance.createTime.label': '创建日期',
        'property.maintenance.createTime.holder': '请输入创建日期',
        'property.maintenance.createTime.required': '创建日期必填',
        'property.maintenance.updateTime.label': '修改日期',
        'property.maintenance.updateTime.holder': '请输入修改日期',
        'property.maintenance.updateTime.required': '修改日期必填',
        'property.maintenance.isDelete.label': '是否删除',
        'property.maintenance.isDelete.holder': '请输入是否删除',
        
        
        'property.maintenance.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.maintenance.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.maintenance.id.label': '主键',
        'property.maintenance.id.holder': '請輸入主键',
        
        
        'property.maintenance.id.required': '主键必填',
        'property.maintenance.maintenanceType.label': '维修类型',
        'property.maintenance.maintenanceType.holder': '請輸入维修类型',
        
        
        'property.maintenance.maintenanceType.required': '维修类型必填',
        'property.maintenance.maintenanceTime.label': '维修时间',
        'property.maintenance.maintenanceTime.holder': '請輸入维修时间',
        
        
        'property.maintenance.maintenanceTime.required': '维修时间必填',
        'property.maintenance.maintenancePeople.label': '维护员工',
        'property.maintenance.maintenancePeople.holder': '請輸入维护员工',
        
        
        'property.maintenance.maintenancePeople.required': '维护员工必填',
        'property.maintenance.maintenanceContent.label': '维修内容',
        'property.maintenance.maintenanceContent.holder': '請輸入维修内容',
        
        
        'property.maintenance.maintenanceContent.required': '维修内容必填',
        'property.maintenance.maintenanceMoney.label': '维修花费',
        'property.maintenance.maintenanceMoney.holder': '請輸入维修花费',
        
        
        'property.maintenance.maintenanceMoney.required': '维修花费必填',
        'property.maintenance.createTime.label': '创建日期',
        'property.maintenance.createTime.holder': '請輸入创建日期',
        
        
        'property.maintenance.createTime.required': '创建日期必填',
        'property.maintenance.updateTime.label': '修改日期',
        'property.maintenance.updateTime.holder': '請輸入修改日期',
        
        
        'property.maintenance.updateTime.required': '修改日期必填',
        'property.maintenance.isDelete.label': '是否删除',
        'property.maintenance.isDelete.holder': '請輸入是否删除',
        
        
        'property.maintenance.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.maintenance.id.label': 'id',
        'property.maintenance.id.holder': 'Enter id',
        'property.maintenance.id.max': 'id max length: 主键',
        
        
        'property.maintenance.id.required': 'id required',
        'property.maintenance.maintenanceType.label': 'maintenanceType',
        'property.maintenance.maintenanceType.holder': 'Enter maintenanceType',
        'property.maintenance.maintenanceType.max': 'maintenanceType max length: 维修类型',
        
        
        'property.maintenance.maintenanceType.required': 'maintenanceType required',
        'property.maintenance.maintenanceTime.label': 'maintenanceTime',
        'property.maintenance.maintenanceTime.holder': 'Enter maintenanceTime',
        'property.maintenance.maintenanceTime.max': 'maintenanceTime max length: 维修时间',
        
        
        'property.maintenance.maintenanceTime.required': 'maintenanceTime required',
        'property.maintenance.maintenancePeople.label': 'maintenancePeople',
        'property.maintenance.maintenancePeople.holder': 'Enter maintenancePeople',
        'property.maintenance.maintenancePeople.max': 'maintenancePeople max length: 维护员工',
        
        
        'property.maintenance.maintenancePeople.required': 'maintenancePeople required',
        'property.maintenance.maintenanceContent.label': 'maintenanceContent',
        'property.maintenance.maintenanceContent.holder': 'Enter maintenanceContent',
        'property.maintenance.maintenanceContent.max': 'maintenanceContent max length: 维修内容',
        
        
        'property.maintenance.maintenanceContent.required': 'maintenanceContent required',
        'property.maintenance.maintenanceMoney.label': 'maintenanceMoney',
        'property.maintenance.maintenanceMoney.holder': 'Enter maintenanceMoney',
        'property.maintenance.maintenanceMoney.max': 'maintenanceMoney max length: 维修花费',
        
        
        'property.maintenance.maintenanceMoney.required': 'maintenanceMoney required',
        'property.maintenance.createTime.label': 'createTime',
        'property.maintenance.createTime.holder': 'Enter createTime',
        'property.maintenance.createTime.max': 'createTime max length: 创建日期',
        
        
        'property.maintenance.createTime.required': 'createTime required',
        'property.maintenance.updateTime.label': 'updateTime',
        'property.maintenance.updateTime.holder': 'Enter updateTime',
        'property.maintenance.updateTime.max': 'updateTime max length: 修改日期',
        
        
        'property.maintenance.updateTime.required': 'updateTime required',
        'property.maintenance.isDelete.label': 'isDelete',
        'property.maintenance.isDelete.holder': 'Enter isDelete',
        'property.maintenance.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.maintenance.isDelete.required': 'isDelete required'
    }
}
